export const css = {
    root: '_1znGJV97',
    heading: 'Me_tV8L8',
    row: '_3vYiWQ9R',
    product: '_3ZvqjFtD',
    primary: '_3l3Y9dhx',
    secondary: '_2zTtZ94_',
    sticky: '_1WmlK-80',
    leading: '_25uGouMc',
    title: '_2tNk1k3H',
    actions: 'bcip-a2S',
    logo: 'Nm2iqUst',
    trailing: '_2BvW9akG',
    spacer: '_3v91D2Lc',
    hamburgerWrapper: '_1LExuiiV',
    hamburger: 'klBLYxk7',
    hamburgerText: '_2f6AzLRV',
    hamburgerMenu: '_2NFFCGA1',
    hamburgerMenuItem: 'EgTFcKeA',
    quizSelect: '_9CREZhfR',
    quizSelectBlock: '_1XcPfmug',
    hideCountdownBlock: '_2ffgiiVz',
    quizSelectChoice: 'fhURRkne',
    quizSelectHidden: '_1wk1ZTQ4',
    examCalendar: 'KTHI8WuL',
    home: '_3qyFlveX',
    nav: '_2LlAGEb6',
    selectFadeOut: 'VarKAwu0',
    ' _key': 'apic-theme/apic/micro/lcc-app/heading'
};
export default css;
